import { useContext } from 'react';

import { AccessibilityContext } from '../../context/accessibility/accessibility-context';

export function useAccessibility() {
  const { state, dispatch } =
    useContext(AccessibilityContext);

  const toggleHighContrast = () => {
    dispatch({ type: 'TOGGLE_HIGH_CONTRAST' });
  };

  const increaseFont = () => {
    dispatch({ type: 'INCREASE_FONT' });
  };

  const decreaseFont = () => {
    dispatch({ type: 'DECREASE_FONT' });
  };

  const resetFont = () => {
    dispatch({ type: 'RESET_FONT' });
  };

  const toggleReaderMode = () => {
    dispatch({ type: 'TOGGLE_READER_MODE' });
  };

  return {
    state,
    toggleHighContrast,
    increaseFont,
    decreaseFont,
    resetFont,
    toggleReaderMode,
  };
}